import { FC, Fragment, useEffect, useMemo } from 'react';
import { ICustomPageSection, SectionType } from '../../../models';
import { getInvalidUrlMessage } from '../../../helpers/customPage';
import { TextField, Grid, Typography } from '@mui/material';
import { getRandomNegativeNumber } from '../../../helpers';
import { DEFAULT_SECTION } from './ManageCustomPage';

interface IIframeSections {
  parentSections: ICustomPageSection[];
  sections: ICustomPageSection[];
  setSections: (val: ICustomPageSection[]) => void;
  index: number;
  parentIndex: number;
}

// IFrames are similar to hero sections. Only one can be displayed per section.
export const IFrameSection: FC<IIframeSections> = ({
  sections,
  parentSections,
  setSections,
  parentIndex,
  index
}) => {
  // use this to deeply copy sections so we don't modify the original array
  const copy: ICustomPageSection[] = JSON.parse(JSON.stringify(parentSections));
  useEffect(() => {
    if (copy[parentIndex].sections[index].sections.length < 1) {
      const randomNumber = getRandomNegativeNumber();
      copy[parentIndex].sections[index].sections.push({
        ...DEFAULT_SECTION,
        customPageSectionId: randomNumber,
        type: SectionType.IFRAME,
        sortOrder: copy[parentIndex].sections[index].sections.length + 1
      });
      setSections(copy);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Typography variant="h6">IFrame Section</Typography>
      <Typography variant="caption" component="p" sx={{ marginBottom: '1rem' }}>
        Add an iframe link.
      </Typography>
      <Grid container spacing={1}>
        {sections.map((sec, subSectionIndex) => {
          const currentItem = copy[parentIndex].sections[index].sections[subSectionIndex];

          return (
            <Fragment key={`${currentItem.customPageSectionId}-${subSectionIndex}`}>
              <Grid item xs={12} md={11}>
                <IframeContent
                  sec={sec}
                  currentItem={currentItem}
                  copy={copy}
                  setSections={setSections}
                />
              </Grid>
            </Fragment>
          );
        })}
      </Grid>
    </>
  );
};

interface IIFrameContent {
  sec: ICustomPageSection;
  currentItem: ICustomPageSection;
  copy: ICustomPageSection[];
  setSections: (val: ICustomPageSection[]) => void;
}

export const IframeContent: FC<IIFrameContent> = ({ sec, currentItem, copy, setSections }) => {
  const isError = useMemo(
    () => !!getInvalidUrlMessage(currentItem.iFrameSrc, false),
    [currentItem.iFrameSrc]
  );

  return (
    <Grid item xs={12} md={11}>
      <TextField
        size="small"
        label="IFrame Link"
        autoComplete="nope"
        variant="outlined"
        value={sec.iFrameSrc}
        fullWidth
        required
        onChange={e => {
          currentItem.iFrameSrc = e.target.value;
          setSections(copy);
        }}
        error={isError}
        helperText={getInvalidUrlMessage(currentItem.iFrameSrc, false)}
      />
    </Grid>
  );
};
